import { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import "./app.scss";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import DetailsPage from "./pages/details/DetailsPage";
import Home from "./pages/home/Home";


function App() {
  const [isMenu, setIsMenu] = useState(false);

  function handleData(data) {
    setIsMenu(data);
  }

  return (
    <BrowserRouter>
      <Header parentCallback={handleData} />
      <AnimatePresence exitBeforeEnter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/:id" element={<DetailsPage />} />
        </Routes>
      </AnimatePresence>
      <Footer />
    </BrowserRouter >
  );
}

export default App;
